/**
 * SeoService
 * Manages document title and meta description dynamically for better SEO and sharing preview.
 */
export const SeoService = {
  updateMeta(title: string, description: string) {
    document.title = `${title} | Arcade Portal`;
    
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', description);
  },

  setGameMeta(gameTitle: string, gameDescription: string) {
    this.updateMeta(
      `Oyna: ${gameTitle}`, 
      `${gameDescription} - Arcade Portal üzerinde hemen ücretsiz oyna!`
    );
  },

  setDefault() {
    this.updateMeta('Oyun Dünyası', 'En iyi klasik ve modern arcade oyunlarını tek bir portalda keşfet ve arkadaşlarınla yarış!');
  }
};
